<template>
    <div class="list-chart">
        <div class="item" v-for="(item, index) in items" :key="index">
            <div class="header text-body-2">
                <label class="label">{{index + 1}}. {{ item.label }}</label>
                <span class="value">{{ `${ item.value }` }}</span>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * ListChart component generates a progress bar with its label for each
 * data item provided as argument.
 */
export default {
    name: 'ListChart',
    props: {
        items: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
.list-chart {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: auto;
    flex: 1;
}

.item {
    display: block;
    height: auto;
    margin: 12px 24px;
}

.item .header {
    display: flex;
    justify-content: space-between;
}

.item .label {
    font-size: 1.1em !important;
    color: var(--v-ddgrey-base);
}

.item .value {
    font-size: 1.1em !important;
    color: var(--v-ddgrey-base);
}

.item:first-child .label {
    font-size: 1.40em !important;
    font-weight: bold;
    color: var(--v-ddwhite-base);
}

.item:nth-child(2) .label {
    font-size: 1.35em !important;
    font-weight: 500;
    color: var(--v-dddarkgrey-base);
}

.item:nth-child(3) .label {
    font-size: 1.28em !important;
    font-weight: 500;
    color: var(--v-ddgrey-base);
}

.item:first-child .value {
    font-size: 1.25em !important;
    font-weight: bold;
    color: var(--v-ddwhite-base);
}

.item:nth-child(2) .value {
    font-size: 1.20em !important;
    font-weight: 500;
    color: var(--v-dddarkgrey-base);
}

.item:nth-child(3) .value {
    font-size: 1.15em !important;
    font-weight: 500;
    color: var(--v-ddgrey-base);
}
</style>